import yup from '../yup-extended';

/*
 * Basics
 * */
export const undefinedSchema = yup.mixed().oneOf([undefined]);
